module.exports = __webpack_public_path__ + "static/img/tv2.7847d23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tv2.jpg
// module id = 3VE7
// module chunks = 30